import React, { useState } from "react";
import { Button } from "../../button/Button";
import { useTranslation } from "react-i18next";
import "./AddListModal.css";

export const AddListModal = ({ onAddList, onCancel, title, placeholder }) => {
    const { t } = useTranslation();
    const [name, setName] = useState("");
    const [isSecret, setIsSecret] = useState(false);

    const handleSubmit = (event) => {
        event?.preventDefault();
        const trimmed = name.trim();
        if (!trimmed) return;

        if (isSecret) {
            onAddList(trimmed, true);
        } else {
            onAddList(trimmed);
        }
        setName("");
    };

    return (
        <div className="add-list-modal-overlay" onClick={onCancel}>
            <div className="add-list-modal" onClick={(e) => e.stopPropagation()}>
                <div className="add-list-modal-title">
                    {title || t('folderMenu.addList')}
                </div>
                <form onSubmit={handleSubmit}>
                    <input
                        type="text"
                        placeholder={placeholder || t('folderMenu.addListName')}
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        autoFocus
                    />
                    {!title && (
                        <label className="add-list-modal-secret-option">
                            <input
                                type="checkbox"
                                checked={isSecret}
                                onChange={(event) => setIsSecret(event.target.checked)}
                            />
                            {t('secretCollections.makeSecret')}
                        </label>
                    )}
                </form>
                <div className="add-list-modal-actions">
                    <Button
                        text={t('confirmationDialog.cancel')}
                        status="secondary"
                        onClick={onCancel}
                    />
                    <Button
                        text={t('confirmationDialog.confirm')}
                        type="primary"
                        onClick={handleSubmit}
                    />
                </div>
            </div>
        </div>
    );
};
